import React from 'react';
import PropTypes from 'prop-types';

import View from './StartWithSelector.view';

const StartWithSelector = ({ onChange, value }) => {
	const handleChange = event => {
		onChange(event.target.value);
	};

	return <View onChange={handleChange} value={value} />;
};

StartWithSelector.propTypes = {
	onChange: PropTypes.func.isRequired,
	value: PropTypes.string.isRequired
};

export default StartWithSelector;
